// extracted by mini-css-extract-plugin
export default {"Clock":"Clock_Clock__cQOwQ","Wrapper":"Clock_Wrapper__cbL+R"};